<div class="login-container">
  <div class="login-panel-left">
    <div class="login-brand">
      <div class="login-logo-row">
        <div class="login-logo-icon">AG</div>
        <div class="login-title">AdGate</div>
      </div>
      <div class="login-subtitle">Commercial Delivery Platform</div>
      <div class="login-subtitle">Latin America</div>
      <div class="login-channels">
        <div class="ch-pill">Disney</div>
        <div class="ch-pill">NatGeo</div>
        <div class="ch-pill">Star</div>
        <div class="ch-pill">FX</div>
        <div class="ch-pill">ESPN</div>
        <div class="ch-pill">Cinecanal</div>
      </div>
    </div>

    <div class="login-tagline">
      © 2026 The Walt Disney Company. All rights reserved.
    </div>
  </div>

  <div class="login-panel-right">
    <div class="login-form-wrapper">
      <h2 class="login-form-title">Welcome Back</h2>
      <p class="login-form-sub">Sign in with your Agency/Customer credentials</p>

      <form [formGroup]="loginForm" class="login-form">
        <mat-label class="mat-form-field-label">Email</mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput type="email" formControlName="login" placeholder="Enter your email" />
        </mat-form-field>

        <mat-label class="mat-form-field-label">Password</mat-label>
        <mat-form-field appearance="outline" class="full-width">
          <input matInput type="password" formControlName="password" placeholder="Enter your password" />
        </mat-form-field>

        <button mat-raised-button type="submit" class="btn-primary" (click)="onLogin()">
          Login
        </button>

        <div class="login-extra">
          <button mat-button type="button" class="link-btn" (click)="onRecoverPassword()">Forgot password?</button>
          <button mat-button type="button" class="link-btn">Need help?</button>
        </div>

        <div class="login-divider">
          <span>or</span>
        </div>

        <button mat-raised-button type="button" class="btn-secondary" (click)="onLoginMyid()">
          <i class="fa-solid fa-id-card"></i>
          Sign in with MyID
        </button>
      </form>
    </div>
  </div>
</div>
